export default __webpack_public_path__ + "static/media/observacion.cdd0df00.jpeg";